import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBars, FaBell, FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import { clearAuthStorage } from '../../utils/authStorage';
import '../../css/components/Header.css';

interface HeaderProps {
  onToggleSidebar: () => void;
  title: string;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar, title }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuthStorage();
    localStorage.removeItem('user');
    navigate('/login');
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return (
    <header className="header">
      <div className="header-left">
        <button className="sidebar-toggle" onClick={onToggleSidebar}>
          <FaBars />
        </button>
        <h1 className="page-title">{title}</h1>
      </div>
      
      <div className="header-right">
        <div className="header-actions">          
          <div className="user-menu">
            <button className="header-btn user-btn">
              <FaUserCircle />
              <span className="user-name">{user.name || 'Admin User'}</span>
            </button>
            
            <button className="header-btn logout-btn" onClick={handleLogout}>
              <FaSignOutAlt />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
